module.exports = __webpack_public_path__ + "img/3.9dbf1da8.jpg";